function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#romantic_svg__clip0_1_91)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.79 1.483C13.658.386 12.434-.106 11.157.019 9.777.154 8.68 1 8.019 1.663 7.356 1.001 6.26.154 4.88.02c-1.277-.125-2.5.367-3.633 1.464C-.16 2.845-.232 4.967.321 6.466c1.006 2.717 3.975 4.81 6.362 6.493.29.205.572.403.84.596a.836.836 0 00.317.138.824.824 0 00.178.021h.009a.86.86 0 00.163-.02l.045-.01a.848.848 0 00.158-.057l.018-.01a.797.797 0 00.103-.063c.27-.194.552-.393.845-.6 2.385-1.68 5.353-3.773 6.356-6.489.554-1.496.484-3.618-.925-4.982zM8.38 11.568l-.362.256-.357-.253C5.466 10.025 2.735 8.1 1.913 5.878c-.362-.982-.344-2.345.515-3.176.766-.742 1.512-1.067 2.28-.995 1.472.14 2.593 1.705 2.614 1.735.011.017.026.03.038.045.02.024.038.048.06.07a.817.817 0 00.072.06c.015.013.027.027.043.038.042.026.07.04.1.055.021.01.042.024.065.033.025.01.051.016.078.024.027.008.053.018.08.023.025.005.05.006.076.008.028.003.057.008.085.008.028 0 .054-.005.081-.007.027-.003.054-.004.08-.01.027-.004.052-.014.078-.021.027-.008.055-.015.08-.025.023-.01.043-.022.064-.032.03-.016.059-.03.086-.048.03-.019.043-.033.058-.045.024-.02.049-.039.072-.061a.817.817 0 00.06-.072c.013-.015.027-.028.038-.044.011-.016 1.139-1.588 2.607-1.732.769-.076 1.518.249 2.287.994.858.831.876 2.193.513 3.174-.82 2.221-3.55 4.145-5.742 5.69z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "romantic_svg__clip0_1_91"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h17v14H0z"
})));

function SvgRomantic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgRomantic;